/**
 * 列选择表格组件
 * 全选/全不选工具栏 + Ant Design Table 纵向表格
 */
import React from 'react';
import { Button, Typography, Table, Select, Switch, Tooltip } from 'antd';
import './ColumnGrid.css';

const { Text } = Typography;

const TYPE_OPTIONS = [
  { value: 'text', label: '文本' },
  { value: 'image', label: '图片' },
  { value: 'video', label: '视频' },
  { value: 'object', label: '主体' },
];

const ColumnGrid = ({
  columnConfigs,
  onIncludeChange,
  onTypeChange,
}) => {
  const selectedCount = columnConfigs.filter(
    (c) => c.includeInLabeling
  ).length;

  const handleSelectAll = () => {
    columnConfigs.forEach((c) => {
      if (!c.includeInLabeling) {
        onIncludeChange(c.columnName, true);
      }
    });
  };

  const handleDeselectAll = () => {
    columnConfigs.forEach((c) => {
      if (c.includeInLabeling) {
        onIncludeChange(c.columnName, false);
      }
    });
  };

  const columns = [
    {
      title: '字段名',
      dataIndex: 'columnName',
      key: 'columnName',
      width: 180,
    },
    {
      title: '字段类型',
      key: 'type',
      width: 140,
      render: (_, record) => (
        <Select
          size="small"
          value={record.userOverrideType || record.detectedType}
          onChange={(val) => onTypeChange(record.columnName, val)}
          options={TYPE_OPTIONS}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: '举例',
      key: 'sample',
      ellipsis: true,
      render: (_, record) => {
        const sample = record.sampleValues?.[0] || '-';
        return (
          <Tooltip title={sample} placement="topLeft">
            <span>{sample}</span>
          </Tooltip>
        );
      },
    },
    {
      title: '是否打标',
      key: 'include',
      width: 100,
      align: 'center',
      render: (_, record) => (
        <Switch
          size="small"
          checked={record.includeInLabeling}
          onChange={(val) => onIncludeChange(record.columnName, val)}
        />
      ),
    },
  ];

  return (
    <div>
      <div className="column-grid-toolbar">
        <Text type="secondary">
          已选择 {selectedCount} / {columnConfigs.length} 列
        </Text>
        <div className="column-grid-toolbar-actions">
          <Button type="link" size="small" onClick={handleSelectAll}>
            一键全选
          </Button>
          <Button type="link" size="small" onClick={handleDeselectAll}>
            一键全不选
          </Button>
        </div>
      </div>

      <Table
        className="column-selection-table"
        columns={columns}
        dataSource={columnConfigs}
        rowKey="columnName"
        pagination={false}
        size="middle"
        scroll={{ x: 600 }}
        rowClassName={(record) => record.includeInLabeling ? 'selected-row' : ''}
      />
    </div>
  );
};

export default ColumnGrid;
